import { useContext } from 'react';
import ExperimentProviderContext from '~/library/helpers/src/experiment/experiment/provider';

function useExperimentBucket(experiment: string, possibleBuckets: string[]) {
  const { experiments, GetAssignedBucket } = useContext(
    ExperimentProviderContext
  );
  const loadedExperiment = experiments[experiment];
  if (!loadedExperiment) {
    GetAssignedBucket({ experimentName: experiment, possibleBuckets });
    return null;
  }

  return loadedExperiment.assignedBucket;
}

export default useExperimentBucket;
